/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Forside_Final_Body_InvitedInputs */

const da_forside_final_body_invited = /** @type {(inputs: Forside_Final_Body_InvitedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Har du en invitation, kan du oprette en konto og rette de første ${i?.count} besvarelser gratis.`)
};

/** @type {(inputs: Forside_Final_Body_InvitedInputs) => LocalizedString} */
const en_forside_final_body_invited = da_forside_final_body_invited;

/**

* @param {Forside_Final_Body_InvitedInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_final_body_invited = /** @type {((inputs: Forside_Final_Body_InvitedInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Final_Body_InvitedInputs, { locale?: "da" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_final_body_invited(inputs)
	return da_forside_final_body_invited(inputs)
});